/* Every layer covers the whole box and shows its glyph through a mask, so the
 * five glyphs share one coordinate system and stay aligned at any size. The
 * glyphs' viewBox already carries the drawing's centring offset. */
.mascot {
  display: flex;
  flex: 0 0 auto;
  width: var(--size);
  height: var(--size);
}

.body {
  position: relative;
  width: 100%;
  height: 100%;
}

.part {
  position: absolute;
  inset: 0;
}

.fill {
  background-color: var(--accent);
  -webkit-mask: url('./body.svg') no-repeat center / contain;
  mask: url('./body.svg') no-repeat center / contain;
}

.outline {
  background-color: var(--ink);
  -webkit-mask: url('./outline.svg') no-repeat center / contain;
  mask: url('./outline.svg') no-repeat center / contain;
}

/* The eyes squeeze shut around their own line, 59% down the box, for a
 * moment about every four and a half seconds. */
.eyes {
  background-color: var(--accent-ink);
  -webkit-mask: url('./eyes.svg') no-repeat center / contain;
  mask: url('./eyes.svg') no-repeat center / contain;
  transform-origin: 50% 59.14%;
  animation: blink 4.5s ease-in-out infinite;
}

.smile {
  background-color: var(--accent-ink);
  -webkit-mask: url('./smile.svg') no-repeat center / contain;
  mask: url('./smile.svg') no-repeat center / contain;
}

/* Closed eyes, two soft curves, shown only while breathing out. */
.lids {
  opacity: 0;
  background-color: var(--accent-ink);
  -webkit-mask: url('./lids.svg') no-repeat center / contain;
  mask: url('./lids.svg') no-repeat center / contain;
  animation: lids 10s ease-in-out infinite;
}

/* Breathe and relax, the blueprint's ten-second breath, six a minute:
 * breathing in (4 s) the brain swells upward from where it sits, 86% down
 * the box, and holds a moment; breathing out (6 s) it settles back, its eyes
 * close and open again. */
.breathe .body {
  transform-origin: 49.6% 85.7%;
  animation: breathe 10s infinite;
}

.breathe .eyes {
  animation: breathe-eyes 10s ease-in-out infinite;
}

@keyframes blink {
  0%, 91%, 100% { transform: scaleY(1); }
  94% { transform: scaleY(0.1); }
  97% { transform: scaleY(1); }
}

@keyframes breathe {
  0% { transform: scale(1, 1); animation-timing-function: cubic-bezier(0.45, 0, 0.4, 1); }
  40%, 50% { transform: scale(1.05, 1.08); animation-timing-function: cubic-bezier(0.45, 0, 0.35, 1); }
  100% { transform: scale(1, 1); }
}

@keyframes breathe-eyes {
  0%, 52%, 94%, 100% { transform: scaleY(1); opacity: 1; }
  58%, 88% { transform: scaleY(0.1); opacity: 0; }
}

@keyframes lids {
  0%, 54%, 92%, 100% { opacity: 0; }
  60%, 86% { opacity: 1; }
}

/* Still for anyone who asks for less motion: eyes open, no breath. */
@media (prefers-reduced-motion: reduce) {
  .eyes,
  .lids,
  .breathe .body,
  .breathe .eyes {
    animation: none;
  }
}
